module.exports = require("@splunk/dashboard-visualizations/Table");